import React, { useState, useRef } from 'react'
import { FileInput } from '@blueprintjs/core'

const FileInputWrapper = props => {
   const [fileName, setFileName] = useState('Choose xml file... ')
   const fileInputRef = useRef(null)

   function setUpFileReader(file, fileName) {
      const reader = new FileReader()
      reader.onload = e => handleFileLoad(fileName, e)
      try {
         reader.readAsText(file)
      } catch (err) {
         console.error(err)
      }
   }

   function handleInputChange() {
      const inputElement = fileInputRef.current
      const fakePathToFile = inputElement.value
      const fileName = fakePathToFile.split('\\').pop()
      setUpFileReader(inputElement.files[0], fileName)
      setFileName(fileName)
      props.updateDownload()
   }

   function handleFileLoad(fileName, event) {
      props.handleFileUpload(fileName, event.target.result)
   }

   return (
      <FileInput
         large
         style={{ marginTop: '40px', textAlign: 'left' }}
         text={fileName}
         onInputChange={handleInputChange}
         inputProps={{ ref: fileInputRef, accept: '.xml', id: 'file' }}
      />
   )
}

export default FileInputWrapper
